import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import APIService from "../../services/api.service";
import CustomProductCard from "./CustomProductCard";
import { useSelector } from "react-redux";

const OnlineShoppingProducts = () => {
  const [products, setProducts] = useState([]);
  const { offers } = useSelector((state) => state.offer);

  useEffect(() => {
    APIService.sendRequest("/api/v1/products/top").then((response) => {
      setProducts(response?.products);
      // console.log(response);
    });
  }, []);

  return (
    <section className="scroll-hidden mb-5">
      <div className="container">
        <h4>
          Online Shopping Cards
          <Link to={"/giftcards?type=onlineshopping"}>View All</Link>{" "}
        </h4>
        <div className="horizontal-scroll d-flex banner-img card-scroll mb-4">
          {products &&
            products.map((product, i) => {
              var offs = offers.filter(
                (offer) => product?.brandName === offer?.productId?.brandName
              );
              var dis = 0;
              if (offs.length > 0) dis = offs[0].discount;

              return (
                <CustomProductCard
                  key={i}
                  image={product?.images?.custom || product?.images?.mobile}
                  name={product.name}
                  discount={dis}
                  productId={product._id}
                />
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default OnlineShoppingProducts;
